import { render, staticRenderFns } from "./dpCommerceReport.vue?vue&type=template&id=ca0e7c6e&scoped=true"
import script from "./dpCommerceReport.vue?vue&type=script&lang=js"
export * from "./dpCommerceReport.vue?vue&type=script&lang=js"
import style0 from "./dpCommerceReport.vue?vue&type=style&index=0&id=ca0e7c6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0e7c6e",
  null
  
)

export default component.exports